import React from 'react';

import DoughnutChart from '@components/charts/Doughnut';

const DesignWisePerformance = ({ summary }) => {
	return (
		<>
			<div className="performance-heading d-flex justify-content-between align-items-center">
				<p className="regular-14 gray_dark_01 weight-500">Nitex Design vs Brand Design</p>
			</div>
			<div className="performance-body">
				<div className="d-flex align-items-center">
					<div className="round-chart">
						<DoughnutChart
							aspectRatio={1.2}
							chartData={{
								labels: ['Nitex Design', 'Brand Design'],
								datasets: [
									{
										data: [summary?.nitexDesignSold, summary?.brandDesignSold],
										backgroundColor: ['#FCB400', '#67AC5B'],
										hoverBackgroundColor: ['#FCB400', '#67AC5B']
									}
								]
							}}
						/>
					</div>
					<div className="pl-3">
						<div className="nitex-design d-flex mb-12">
							<span className="color-indicator nitex-design" />
							<p className="regular-12 weight-500">Nitex Design</p>
						</div>
						<div className="brand-design d-flex">
							<span className="color-indicator brand-design" />
							<p className="regular-12 weight-500">Brand Design</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DesignWisePerformance;
